<template>
  <div id="app">
    <router-view class="routerView" />
  </div>
</template>

<script>
import "./font/iconfont.js";
export default {
  name: "App",
  created() {
    if (!localStorage.getItem("language")) {
      localStorage.setItem(
        "language",
        JSON.stringify({
          icon: require("@/static/img/Brazil.svg"),
          option: "PT",
          value: "pt"
        })
      );
    }
  }
};
</script>

<style>
@font-face {
  font-family: 'Gotham-Light';
  src: url('font/gotham/Gotham-Light.eot');
  src: url('font/gotham/Gotham-Light.eot?#iefix') format('embedded-opentype'),
  url('font/gotham/Gotham-Light.svg#roboto-regular-webfont') format('svg'),
  url('font/gotham/Gotham-Light.woff') format('woff'),
  url('font/gotham/Gotham-Light.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Gotham-Book';
  src: url('font/gotham/Gotham-Book.eot');
  src: url('font/gotham/Gotham-Book.eot?#iefix') format('embedded-opentype'),
  url('font/gotham/Gotham-Book.svg#roboto-regular-webfont') format('svg'),
  url('font/gotham/Gotham-Book.woff') format('woff'),
  url('font/gotham/Gotham-Book.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Gotham-Medium';
  src: url('font/gotham/Gotham-Medium.eot');
  src: url('font/gotham/Gotham-Medium.eot?#iefix') format('embedded-opentype'),
  url('font/gotham/Gotham-Medium.svg#roboto-regular-webfont') format('svg'),
  url('font/gotham/Gotham-Medium.woff') format('woff'),
  url('font/gotham/Gotham-Medium.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Gotham-Bold';
  src: url('font/gotham/Gotham-Bold.eot');
  src: url('font/gotham/Gotham-Bold.eot?#iefix') format('embedded-opentype'),
  url('font/gotham/Gotham-Bold.svg#roboto-regular-webfont') format('svg'),
  url('font/gotham/Gotham-Bold.woff') format('woff'),
  url('font/gotham/Gotham-Bold.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

* {
  padding: 0;
  margin: 0;
}

#app,
body,
html {
  font-family: 'Plus Jakarta Sans';
  width: 100%;
  background-color: radial-gradient(57.14% 57.14% at 50% 7.14%, #4B227A 0%, rgba(75, 34, 122, 0) 100%);
  background-image: url('../src/static/images/main-bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.app_bg {
  height: 100%;
  width: 100%;
  object-fit: cover;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1;
}
.routerView {
  position: relative;
  z-index: 1;
}
html,
body {
  min-width: 1024px;
}
div,
span,
p,
a {
  box-sizing: border-box;
}

a {
  text-decoration: none;
  outline: none;
}

.swiper-pagination-bullets {
  span {
    width: 10px;
    height: 10px;
    background: #FFF!important;
    opacity: 1!important;
    margin: 0 5px;
  }

  span.swiper-pagination-bullet-active {
    background: #44D464!important;
  }
}


.button-mini-banner .swiper-pagination-bullets span.swiper-pagination-bullet-active {      
  width: 48px;
  border-radius: 10px;
  background: #FFF!important;
}

form {
  .el-form-item__label {
      font-family: 'Gotham-Book';
      font-size: 14px;
      line-height: 24px;
      color: #CCC!important;
      margin: 0 auto 10px;
      padding: 0!important;
      display: contents;
  }

  div[element-loading-spinner="el-icon-loading"] {
    width: 28%!important;
    height: auto!important;
    line-height: 0;

    .el-image {
      width: 100%!important;
      height: auto!important;
    }
  }
}

@media (max-width: 540px) {
  html,
  body {
    min-width: unset;
  }
  #app {
    margin: 0 auto;
  }
}

</style>




// WEBPACK FOOTER //
// src/App.vue